import axiosInstance from '@/api';
import { EmailServerServiceType } from '@/services/api/emailServerApiArea/interface';
import {
  EmailServerGetParams,
  EmailServerIntegrationType,
  EmailServerServiceCheckIntegrationParams,
  IMailServer
} from '@/services/api/emailServerApiArea/types';

export class EmailServerService implements EmailServerServiceType {
  PrepareValues(value: IMailServer): IMailServer {
    if (value.Integration.Type === EmailServerIntegrationType.None) {
      return {
        ...value,
        Integration: {
          ...value.Integration,
          Ssh: null,
          Api: null
        }
      };
    }

    return {
      ...value,
      Integration: {
        ...value.Integration,
        Ssh: value.Integration?.Ssh
          ? {
              ...value.Integration?.Ssh,
              HasKey: value?.Integration?.Ssh?.PrivateKeyBase64.length !== 0
            }
          : null
      }
    };
  }

  async GetEmailServer(params: EmailServerGetParams): Promise<IMailServer> {
    try {
      const { data } = await axiosInstance.post<IMailServer>('v1/EmailServer', params);

      return data;
    } catch (e) {
      throw new Error('Unable to update customer. Please try again later.');
    }
  }

  async EmailServerSave(params: IMailServer): Promise<IMailServer> {
    try {
      const { data } = await axiosInstance.post<IMailServer>('v1/EmailServer/Save', params);

      return data;
    } catch (e) {
      throw new Error('Unable to update customer. Please try again later.');
    }
  }

  async EmailServerCheckIntegration(
    params: EmailServerServiceCheckIntegrationParams
  ): Promise<void> {
    try {
      await axiosInstance.post<void>('v1/EmailServer/CheckIntegration', params);
    } catch (e) {
      throw new Error('Unable to update customer. Please try again later.');
    }
  }
}
